import React, { ReactNode, useState } from 'react'

type TTooltip = {
  text: string
  children: ReactNode
}

export default function Tooltip({ text, children }: Readonly<TTooltip>) {
  const [isHovered, setIsHovered] = useState(false)

  return (
    <div
      role='button'
      tabIndex={0}
      className='relative inline-block'
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onFocus={() => setIsHovered(true)}
      onBlur={() => setIsHovered(false)}
    >
      {children}
      <div
        className={`${
          isHovered ? 'visible opacity-100' : 'invisible opacity-0'
        } absolute -translate-y-2 scale-95 transform rounded-md bg-gray-800 p-2 text-white transition-opacity duration-300`}
      >
        {text}
      </div>
    </div>
  )
}
